import { useMutation } from "@tanstack/react-query";
import {
  sendPrescriptionEmail,
  cancelOnlinePrescription,
} from "../services/ePrescriptionDetailService";

export const useSendPrescriptionEmail = () => {
  return useMutation({
    mutationFn: ({
      prescriptionId,
      token,
    }: {
      prescriptionId: string;
      token: string;
    }) => sendPrescriptionEmail(prescriptionId, token),
  });
};

export const useCancelOnlinePrescription = () => {
  return useMutation({
    mutationFn: ({
      prescriptionId,
      token,
    }: {
      prescriptionId: string;
      token: string;
    }) => cancelOnlinePrescription(prescriptionId, token),
  });
};